var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnexo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0376 8.51779L11.3289 15.4088C10.262 16.253 8.81496 16.7273 7.30616 16.7273C5.79735 16.7273 4.35034 16.253 3.28345 15.4088C2.21656 14.5646 1.61719 13.4196 1.61719 12.2257C1.61719 11.0319 2.21656 9.88687 3.28345 9.04268L11.9922 2.15168C12.7035 1.58888 13.6681 1.27271 14.674 1.27271C15.6799 1.27271 16.6446 1.58888 17.3558 2.15168C18.0671 2.71448 18.4667 3.4778 18.4667 4.27372C18.4667 5.06964 18.0671 5.83296 17.3558 6.39575L8.63758 13.2867C8.28195 13.5681 7.79962 13.7262 7.29668 13.7262C6.79374 13.7262 6.31141 13.5681 5.95578 13.2867C5.60015 13.0053 5.40036 12.6237 5.40036 12.2257C5.40036 11.8278 5.60015 11.4461 5.95578 11.1647L14.0012 4.8061",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnexo);
export default __webpack_public_path__ + "static/media/anexo.4fc7c356a89eae9a72b7b5e0dd1952b6.svg";
export { ForwardRef as ReactComponent };